// This icon file is generated automatically.
var PFileMarkdownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.35 3.5L9 .16A.5.5 0 008.64 0H2a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V3.86a.5.5 0 00-.15-.35zm-1 .6H8.4V1.14l2.94 2.94zm.03 8.78H2.62V1.12h4.72V4.5c0 .36.3.66.66.66h3.38v7.71zM5.7 6.51a.19.19 0 00-.17-.11h-.55c-.1 0-.18.08-.18.18v4.25c0 .1.08.2.18.2h.43c.1 0 .19-.1.19-.2V8.1l1.04 2.34c.03.07.1.11.17.11h.38a.2.2 0 00.17-.1L8.4 8.08v2.75c0 .1.09.2.2.2h.42c.1 0 .18-.1.18-.2V6.6c0-.1-.08-.18-.18-.18h-.55a.19.19 0 00-.17.1l-1.3 3-1.3-3z", "fill-rule": "nonzero" } }] }, "name": "p-file-markdown", "theme": "outlined" };
export default PFileMarkdownOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFileMarkdownOutlined.js
// module id = 3388
// module chunks = 0